import type { IconData } from '@stacksjs/iconify-core'

export const closeCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m11.414 10l2.829 2.828a1 1 0 0 1-1.415 1.415L10 11.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L8.586 10L5.757 7.172a1 1 0 0 1 1.415-1.415L10 8.586l2.828-2.829a1 1 0 0 1 1.415 1.415zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default closeCircle
